import api from './api'
import { API_ENDPOINTS } from '../config/api'

const multiLoginService = {
  create: async (data) => {
    const response = await api.post(API_ENDPOINTS.MULTI_LOGIN.CREATE, data)
    return response.data
  },
  list: async () => {
    const response = await api.get(API_ENDPOINTS.MULTI_LOGIN.LIST)
    return response.data
  },
  // Body: { permissions?, email?, full_name?, active? } — permissions merge server-side
  update: async (id, data) => {
    const response = await api.put(`${API_ENDPOINTS.MULTI_LOGIN.BASE}/${id}`, data)
    return response.data
  },
  // Omit `active` to toggle
  setActive: async (id, active) => {
    const response = await api.patch(
      `${API_ENDPOINTS.MULTI_LOGIN.BASE}/${id}/active`,
      active === undefined ? {} : { active }
    )
    return response.data
  },
  changePassword: async (id, password) => {
    const response = await api.post(`${API_ENDPOINTS.MULTI_LOGIN.BASE}/${id}/password`, { password })
    return response.data
  },
  remove: async (id) => {
    const response = await api.delete(`${API_ENDPOINTS.MULTI_LOGIN.BASE}/${id}`)
    return response.data
  },
}

export default multiLoginService
